import { generatePath, Redirect, Switch, useLocation, useParams, Route } from 'react-router-dom';
import Loadable from 'UIComponents/decorators/Loadable';
import Lesson from './routes/Lesson';
// @ts-expect-error Could not find a declaration file for module
import DashboardPageLayoutRoute from './components/Layouts/DashboardPageLayoutRoute';
import Homepage from './routes/Homepage';

// @ts-expect-error Could not find a declaration file for module
import TrackPageRouter from './containers/TrackPage/TrackPageRouter';
import { PracticalExerciseFrame } from './features/practicalExercise';
import Catalog from './routes/Catalog';
// @ts-expect-error Could not find a declaration file for module
import WeekOfRestBanner from './components/Banners/WeekOfRestBanner';
import { RESULTS_URL_FRAGMENT, PRACTICAL_EXERCISE_URL_FRAGMENT, PAGE_NAMES, TRACKS_URL_FRAGMENT, PARTNER_TRACKS_URL_FRAGMENT, FAVORITES_URL_FRAGMENT, WIZARD_URL_FRAGMENT, COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, CREATE_PLAYLIST_URL_FRAGMENT, SAVED_ITEMS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, DUPLICATE_PLAYLIST_URL_FRAGMENT, EDIT_PLAYLIST_URL_FRAGMENT, ASSIGN_PLAYLIST_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, LEGACY_SHARE_AWARD_URL_FRAGMENT, AWARD_URL_FRAGMENT, SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT, SHORT_OVERVIEW_URL_FRAGMENT, MYLEARNING_URL_FRAGMENT } from './constants/Navigation';
import WizardPage from './containers/Wizard/WizardPage';
// @ts-expect-error Could not find a declaration file for module
import TrackAwardModalContainer from './containers/TracksPage/TrackAwardModalContainer';
// @ts-expect-error Could not find a declaration file for module
import EngagementTracking from './EngagementTracking';
import NewUserLanding from './components/Landing/NewUserLanding';
import AchievementPreviewModal from './components/Modals/AchievementPreviewModal';
import { HUBSPOT_SOFTWARE_INDEX } from './features/wizard';
import AwardShareControls from './components/AwardShareControls';
import SavedItemsLayout from './components/Layouts/SavedItemsLayout';
import Favorites from './routes/Favorites';
import MyPlaylists from './routes/MyPlaylists';
import Playlist from './routes/Playlist';
import enviro from 'enviro';
import { LANGUAGES } from './constants/TopFilterConstants';
import CreatePlaylist from './routes/CreatePlaylist';
import { useShowDevtools } from './features/devtools/devtoolsQueries';
import EditPlaylist from './routes/EditPlaylist';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { useHasGate } from './features/accounts';
import AuthenticatedCourseBrochure from './features/brochure/components/AuthenticatedCourseBrochure';
import DuplicatePlaylist from './routes/DuplicatePlaylist';
import AssignPlaylist from './routes/AssignPlaylist';
import { MY_PLAYLISTS_TABS } from './features/myPlaylists';
import { ShortContentRoute } from './routes/ShortContent';
import { NamedRoute } from './features/routing';
import { OverviewModal } from './features/overview';
import MyLearningRouter from './routes/MyLearningRouter';
import { MY_LEARNING_TABS, MyLearningTabs } from './features/myLearning';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RedirectToTracksWithQueryParams = () => {
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  if (/cat=|tools=|awardType=|level=|duration=|contentType=|language=/i.test(search)) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Object.assign({}, location, {
        pathname: RESULTS_URL_FRAGMENT
      })
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace('/tracks', '')
    })
  });
};
const RedirectToWatchLater = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(FAVORITES_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT)
    })
  });
};
const RedirectToAward = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const RedirectToAwardShare = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_SHARE_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(SHARE_AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const Team = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/team" */'./routes/Team').then(mod => mod.default)
});
const PartnerPage = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/partners" */
  './routes/Partners').then(mod => mod.default)
});
const QaOnlyRoutes = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/qaOnly" */'./components/QaOnly/QaOnlyRoutes').then(mod => mod.default)
});
const Devtools = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/devtools" */'./features/devtools').then(mod => mod.Devtools)
});
const RemoveTrailingSlash = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(/\/+$/, '')
    })
  });
};
const HomepageBanners = () => /*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsx(WeekOfRestBanner, {})
});
const WatchLaterRoutePaths = [`${WATCH_LATER_URL_FRAGMENT}/page/:page`, WATCH_LATER_URL_FRAGMENT];
const myPlaylistsTabs = MY_PLAYLISTS_TABS.join('|');
export const MyPlaylistsRoutePaths = [`${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})?`];
export const WizardRoutePaths = [`${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup?/:category?/:certsOnly(true|false)?`, `${WIZARD_URL_FRAGMENT}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/:categoryGroup?/:category?/:certsOnly(true|false)?`];
const languages = LANGUAGES.join('|');
export const OverviewRoutePaths = [`(.*)${COURSE_OVERVIEW_URL_FRAGMENT}/:trackId/:source/:language(${languages})?/`, `(.*)${COURSE_OVERVIEW_URL_FRAGMENT}/:trackId/:language?/`, `(.*)${LESSON_OVERVIEW_URL_FRAGMENT}/:lessonId/:source/:language(${languages})?/`, `(.*)${LESSON_OVERVIEW_URL_FRAGMENT}/:lessonId/:language?/`, `(.*)${SHORT_OVERVIEW_URL_FRAGMENT}/`];
const RedirectToMyLearning = () => {
  return /*#__PURE__*/_jsx(Redirect, {
    to: MYLEARNING_URL_FRAGMENT
  });
};
const myLearningTabs = MY_LEARNING_TABS.join('|');
export const MyLearningRoutePaths = [`${MYLEARNING_URL_FRAGMENT}/:tab(${myLearningTabs})?`];
const LegacyMyLearningRoutePaths = [`${MYLEARNING_URL_FRAGMENT}/:status?`, `${MYLEARNING_URL_FRAGMENT}/:status/page/:page`];
export const Routes = () => {
  const showDevtools = useShowDevtools();
  const hasSunsetGate = useHasGate('Academy:SunsetCMS');
  const hasShortsGate = useHasGate('Academy:ShortFormContent');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {}), showDevtools && /*#__PURE__*/_jsx(Devtools, {}), /*#__PURE__*/_jsx(NewUserLanding, {}), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RemoveTrailingSlash,
        path: "/*(/+)"
      }), /*#__PURE__*/_jsx(Route, {
        component: PracticalExerciseFrame,
        path: `${PRACTICAL_EXERCISE_URL_FRAGMENT}/:contentId/:lessonId/:trackId?`
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: WizardPage,
        name: PAGE_NAMES.WIZARD,
        path: WizardRoutePaths
      }), hasSunsetGate && /*#__PURE__*/_jsx(NamedRoute, {
        component: AuthenticatedCourseBrochure,
        exact: true,
        name: PAGE_NAMES.COURSE,
        path: `${TRACKS_URL_FRAGMENT}/:trackId(\\d+)`
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: TrackPageRouter,
        name: PAGE_NAMES.COURSE,
        path: [`${TRACKS_URL_FRAGMENT}/:trackId(\\d+)/:lessonId?/:contentId?`]
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: Lesson,
        name: PAGE_NAMES.LESSON,
        path: "/lessons/:lessonId/:contentId?"
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: AwardShareControls,
        exact: true,
        name: PAGE_NAMES.AWARD_SHARE,
        path: [SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT]
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToAwardShare,
        path: LEGACY_SHARE_AWARD_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Homepage,
        exact: true,
        headerSearch: true,
        maybeBanner: HomepageBanners,
        name: PAGE_NAMES.CATALOG,
        path: "/",
        searchResultsRedirect: true,
        titleKey: "HOME"
      }), /*#__PURE__*/_jsx(Redirect, {
        from: `${RESULTS_URL_FRAGMENT}/page/:page`,
        to: RESULTS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Catalog,
        headerSearch: true,
        name: PAGE_NAMES.CATALOG,
        path: RESULTS_URL_FRAGMENT,
        titleKey: "CATALOG"
      }), /*#__PURE__*/_jsx(Redirect, {
        from: `${PARTNER_TRACKS_URL_FRAGMENT}/page/:page`,
        to: PARTNER_TRACKS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: PartnerPage,
        headerSearch: true,
        name: PAGE_NAMES.PARTNER,
        path: PARTNER_TRACKS_URL_FRAGMENT,
        titleKey: "PARTNERS"
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Team,
        maybeBanner: WeekOfRestBanner,
        name: PAGE_NAMES.TEAM,
        path: "/team",
        titleKey: "MY_TEAM"
      }), hasShortsGate ? /*#__PURE__*/_jsx(NamedRoute, {
        component: MyLearningTabs,
        exact: true,
        name: PAGE_NAMES.MY_LEARNING,
        path: MyLearningRoutePaths
      }) : /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: MyLearningRouter,
        maybeBanner: WeekOfRestBanner,
        name: PAGE_NAMES.MY_LEARNING,
        path: [`${MYLEARNING_URL_FRAGMENT}/:status?`, `${MYLEARNING_URL_FRAGMENT}/:status/page/:page`],
        titleKey: "MY_LEARNING"
      }), hasShortsGate && /*#__PURE__*/_jsx(Route, {
        component: RedirectToMyLearning,
        path: LegacyMyLearningRoutePaths
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToWatchLater,
        path: FAVORITES_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(Route, {
        path: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(NamedRoute, {
            exact: true,
            name: PAGE_NAMES.PLAYLISTS,
            path: MyPlaylistsRoutePaths,
            children: /*#__PURE__*/_jsx(SavedItemsLayout, {
              children: /*#__PURE__*/_jsx(MyPlaylists, {})
            })
          }), /*#__PURE__*/_jsx(NamedRoute, {
            component: Playlist,
            exact: true,
            name: PAGE_NAMES.PLAYLISTS,
            path: [PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT]
          })]
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: SAVED_ITEMS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(SavedItemsLayout, {
          children: /*#__PURE__*/_jsx(Switch, {
            children: /*#__PURE__*/_jsx(NamedRoute, {
              component: Favorites,
              name: PAGE_NAMES.SAVED_ITEMS,
              path: WatchLaterRoutePaths
            })
          })
        })
      }), enviro.isQa() && /*#__PURE__*/_jsx(Route, {
        component: QaOnlyRoutes,
        path: "/qa-only"
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToTracksWithQueryParams,
        path: "/tracks"
      }), /*#__PURE__*/_jsx(ShortContentRoute, {}), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Homepage,
        headerSearch: true,
        maybeBanner: HomepageBanners,
        name: PAGE_NAMES.CATALOG,
        searchResultsRedirect: true,
        titleKey: "HOME"
      })]
    }), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RedirectToAward,
        path: `(.*)${LEGACY_AWARD_URL_FRAGMENT}`
      }), /*#__PURE__*/_jsx(Route, {
        component: TrackAwardModalContainer,
        path: `(.*)${AWARD_URL_FRAGMENT}`
      })]
    }), /*#__PURE__*/_jsx(Route, {
      component: AchievementPreviewModal,
      path: SHARE_AWARD_PREVIEW_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: OverviewModal,
      path: OverviewRoutePaths
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/tracks/:trackId(\\d+)`
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/lessons/:lessonId(\\d+)`
    }), /*#__PURE__*/_jsx(Route, {
      component: CreatePlaylist,
      path: `(.*)${CREATE_PLAYLIST_URL_FRAGMENT}/`
    }), /*#__PURE__*/_jsx(Route, {
      component: EditPlaylist,
      path: `(.*)${PLAYLIST_URL_FRAGMENT}${EDIT_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(Route, {
      component: DuplicatePlaylist,
      path: `(.*)${PLAYLIST_URL_FRAGMENT}${DUPLICATE_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(Route, {
      component: AssignPlaylist,
      path: `(.*)${ASSIGN_PLAYLIST_URL_FRAGMENT}`
    })]
  });
};
export default Routes;